import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const paramsList = [ 'partnerRequests', 'cpc', 'wins', 'wins %', 'clicks', 'impressions', 'ctr', 'eCpm', 'revenue' ];
const totalParamsList = [ 'totalPartnerRequests', 'avgCpc', 'totalWins', 'totalWins %', 'totalClicks', 'totalImpressions', 'avgCtr', 'avgECpm', 'totalRevenue' ];

const BidderTable = ({ data, requests, countries, sources }) => {
    const header = sources.map(source => <th key={source}>{source}</th>);
    const rows = countries.reduce((arr, country, rowIndex) => {
        paramsList.forEach((param, index) => {
            const showCountry = index === 0;
            arr.push(<Row country={country} param={param} showCountry={showCountry} data={data} requests={requests} key={`${param}_${rowIndex}`} sources={sources}/>)
        });

        return arr;
    }, []);
    const totalRow = totalParamsList.map((param, index) => {
        const showCountry = index === 0;

        return <Row country={'TOTAL'} param={param} showCountry={showCountry} data={data} sources={sources} key={index}/>;
    });

    return (
        <Table bordered responsive>
            <thead>
            <tr>
                <th>Country</th>
                <th>Parameter</th>
                {header}
                <th>Total</th>
            </tr>
            </thead>
            <tbody>
                {rows}
                {totalRow}
            </tbody>
        </Table>
    );
};

export default BidderTable;


// WEBPACK FOOTER //
// ./src/scenes/Bidder2/components/Table/index.js